'use client';

import { LanguageType } from '@/constant/localeData';
import useLocaleChange from '@/hooks/useLocaleChange';

const LANGUAGES: Array<LanguageType> = [
  { key: 'de', title: 'DE' },
  { key: 'en', title: 'EN' },
];

export default function LanguageToggle() {
  const { changeLanguage, defaultLocale } = useLocaleChange();

  const handleToggle = (language: string) => {
    changeLanguage(language);
  };

  const selectedIndex = LANGUAGES.findIndex(
    (lang) => lang.key === defaultLocale.lang?.key
  );

  return (
    <div className="inline-flex items-center gap-1 rounded-full border border-gray-200 bg-[#f9f9f9] p-1">
      {LANGUAGES.map((language) => (
        <button
          key={language.key}
          onClick={() => handleToggle(language.key)}
          className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
            defaultLocale.lang?.key === language.key
              ? 'bg-pink-500 text-white'
              : 'text-gray-600'
          }`}
        >
          {language.title}
        </button>
      ))}
    </div>
  );
}
